<script>
import { mapActions, mapGetters } from "vuex";
import Multiselect from 'vue-multiselect'
export default {
    props: ['value', 'disabled'],
    components: { Multiselect },
    data() {
        return {
            users: [],
            selectedUser: this.value,
        }
    },
    computed: {
        ...mapGetters(["auth"]),
        selectedUserLabel() {
            return this.selectedUser ? (this.selectedUser.firstname + " "+this.selectedUser.lastname) : null;
        }
    },
    methods: {
        ...mapActions(['getUsers']),
        userLabel (user) {
            return user.firstname + " " + user.lastname + " <" + user.email + ">";
        }
    },
    mounted() {
        this.getUsers().then(response => {
            this.users = response.data.users;
        });
    },
}
</script>
<template>
    <div class="d-flex flex-row p-4 justify-content-center align-items-center">
        <div class="pr-1">Faire l'envoi en tant que : </div>
        <multiselect
            v-model="selectedUser"
            class="user-multiselect" 
            :options="users"
            :show-labels="false"
            :custom-label="userLabel"
            selectLabel="Appuyer sur entrer ou cliquer"
            deselect-label="" 
            track-by="id"
            placeholder="Selectionner ou rechercher un utilisateur"
            @input="$emit('input', selectedUser)"
            :allow-empty="false">
        </multiselect>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .user-multiselect {
        .multiselect__single {
            font-size: 0.9rem;
        }
        width: 500px;
    }
</style>